import { filterNavigation } from './navigation';
import { Environment } from './environment.types';
import developmentEnvironment from './environment.development';

const environment: Partial<Environment> = {
  ...developmentEnvironment,
  navigation: filterNavigation(
    'Dashboard',
    'Documents',
    'SCAR',
    'Supplier Management',
    'Teams',
    'Employees',
    'Workflow',
    'Task Types'
  )
};

export default environment;
